var tmpl = require('./tmpl.handlebars')

module.exports = function(container) {
  $('body').append(tmpl())
    .on('touchstart', '.page-share-tip', function() {
      $('.page-share-tip').remove()
    })
}